import { validateAddress } from '../utils';

export const initialState = {
  addresses: [],
  name: '',
  loading: false,
  searchPostcode: '',
  searchPostcodeError: false,
  signedInPostcodeError: false,
  selectedAddress: {
    name: '',
    line_1: '',
    line_2: '',
    line_3: '',
    line_4: '',
    line_5: '',
    postcode: '',
  },
  selected: null,
  showNameError: false,
  telephone: '',
  showTelephoneError: false,
  guestAddressMode: '',
  showManualAddressForm: false,
  showManualAddressButton: false,
  postcodeErrorMessage: 'No Addresses found for postcode',
  postcodeExcluded: false,
  isPostcodeValid: false,
  newAddressValid: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GUEST_DELIVERY_ADDRESS':
      return {
        ...state,
        selected: action.payload,
        selectedAddress: {
          name: state.name,
          line_1: action.payload.line_1,
          line_2: action.payload.line_2,
          line_3: action.payload.line_3,
          line_4: action.payload.line_4,
          line_5: action.payload.line_5,
          postcode: action.payload.postcode,
        },
        showManualAddressForm: true,
        ...(validateAddress(action.payload)
          ? { newAddressValid: true, selected: action.payload }
          : { newAddressValid: false, selected: null }),
      };
    case 'SET_SHOW_NAME_ERROR':
      return { ...state, showNameError: action.payload };
    case 'SET_SHOW_TELEPHONE_ERROR':
      return { ...state, showTelephoneError: action.payload };
    case 'SET_TELEPHONE':
      return { ...state, telephone: action.payload, showTelephoneError: false };
    case 'SET_GUEST_NAME':
      return {
        ...state,
        name: action.payload,
        selectedAddress: { ...state.selectedAddress, name: action.payload },
      };
    case 'SET_POSTCODE_ADDRESSES':
      return {
        ...state,
        addresses: action.payload,
        loading: false,
        showManualAddressButton: true,
        postcodeExcluded: false,
      };
    case 'SET_POSTCODE_LOOKUP_ERROR':
      return {
        ...state,
        searchPostcodeError: true,
        postcodeErrorMessage: action.payload.errorMessage,
        postcodeExcluded: !!action.payload.excluded,
        loading: false,
        addresses: [],
        guestAddressMode: 'NEW_ADDRESS',
        showManualAddressButton: false,
      };
    case 'CLEAR_POSTCODE_ADDRESSES':
      return {
        ...state,
        addresses: [],
        showManualAddressForm: false,
        selected: null,
        searchPostcodeError: false,
      };
    case 'SET_SEARCH_POSTCODE':
      return {
        ...state,
        searchPostcode: action.payload.postcode,
        isPostcodeValid: action.payload.isValid,
      };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SIGNED_IN_POSTCODE_ERROR':
      return { ...state, signedInPostcodeError: action.payload };
    case 'SET_SELECTED_ADDRESS':
      return {
        ...state,
        selectedAddress: action.payload,
        ...(validateAddress(action.payload)
          ? { newAddressValid: true, selected: action.payload }
          : { newAddressValid: false, selected: null }),
      };
    case 'VALIDATE_NEW_ADDRESS_INPUT':
      return state.name !== '' &&
        state.selectedAddress.line_1 !== '' &&
        state.selectedAddress.line_3 !== '' &&
        state.isPostcodeValid
        ? { ...state, newAddressValid: true, selected: state.selectedAddress }
        : { ...state, newAddressValid: false, selected: null };
    case 'SET_SHOW_MANUAL_ADDRESS_FORM':
      return { ...state, showManualAddressForm: action.payload };
    default:
      return state;
  }
};
